<script>
    import { layoutOption, mode, memberInfo, apiConfig, queryStr, cipherText } from '../store/inapp-store'
    import { inappFetch } from '../store/inapp-auth'
    import { getAuthVAsync } from '../store/openpoint'
    import { Modal, Loader, Warning } from '../components';
    import { onMount } from 'svelte';

    $layoutOption.showBanner = false
    $layoutOption.showCarousel = false

    let loader = { content : '會員資訊確認中...' };
    let isBlock = true;

    let modal = {
        title : '循環杯',
        message : '取得會員資訊發生錯誤',
        type: 'alert'
    }

    let isOpen = false

    $:console.log('mode' , $mode)

    onMount(async () =>{
        if ($memberInfo.foen) {
            location.href = '/register-info'
            return
        }

        if($mode === 'app') {
            try {
                let testers = [{gid: 'GID36770151296800', tel: '0905000004'}, {gid: 'GID56955201296851', tel: '0999107103'}]
                // 如果 testers 中有 $memberInfo.gid，則直接賦值 $memberInfo.foen 並跳轉到 register-info
                // 主要是因為這兩組是愛金卡提供的測試GID，方便測試使用
                let tester = testers.find(t => t.gid === $memberInfo.gid)
                if(tester) {
                    $memberInfo.foen = tester.tel
                    location.href = '/register-info'
                } else {
                    $memberInfo.authV = ''
                    const authV = await getAuthVAsync()
                    await getMemberPhone(authV)
                }
            } catch(e) {
                showDialog(e.msg || e.message || '取得會員資訊發生錯誤')
            }
        } else {
            setTimeout(setMockMemberPhone, 1000)
        }
    })

    $:console.log('member phone' , $memberInfo.foen)

    /**
     * 取得會員手機號碼
     */
    async function getMemberPhone(authV) {
        try {
            const response = await inappFetch(`${$apiConfig.apiUrl}/member/phone?code=${$apiConfig.apiKey}`, {
                method: 'POST',
                body: JSON.stringify({ gid: $memberInfo.gid, authv: authV, ct: $cipherText })
            })
            const d = await response.json()
            console.log(d)
            if (d.returnCode === '0000') {
                $memberInfo.foen = d.info.phone
                location.href = '/register-info'
            } else {
                isBlock = false
                isOpen = true
            }
        } finally {
            $memberInfo.authV = ''
        }
    }

    /**
     * 取得會員手機號碼（不透過AuthV）
     */
    function setMockMemberPhone() {
        $memberInfo.foen = '0910002003'
        location.href = '/register-info'
    }
    
    function showDialog(msg) {
        modal.message  = msg
        isBlock = false
        isOpen = true 
    }
</script>

<Loader {loader} {isBlock}></Loader>

<Modal {modal} {isOpen} on:closeModal={e => location.href = '/home'+ $queryStr }></Modal>
